import { atom } from 'jotai';
import { atomFamily } from 'jotai-family';
import localforage from 'localforage';
import { localForageEffect } from '../../store/jotai/effects/localForageEffect';
import type { NavigatorTab } from './components/NavigatorTabs';
import { NavigatorItem } from './types';

export const getIsNavigatorOpenFromIndexedDb = async (): Promise<boolean> => {
  const isNavigatorOpen = await localforage.getItem<boolean>('isNavigatorOpen');
  if (isNavigatorOpen === null) {
    return true;
  }
  return isNavigatorOpen;
};

const initSelectedNavigatorItem = async (): Promise<NavigatorItem> => {
  const saved = await localforage.getItem<NavigatorItem>('selectedNavigatorItem');
  return saved ?? 'vehicles';
};

export const isNavigatorOpenAtom = atom<boolean | Promise<boolean>>(
  getIsNavigatorOpenFromIndexedDb()
);
export const isNavigatorOpenEffectAtom = localForageEffect(isNavigatorOpenAtom, 'isNavigatorOpen');

export const selectedNavigatorItemAtom = atom<NavigatorItem | Promise<NavigatorItem>>(
  initSelectedNavigatorItem()
);
export const selectedNavigatorItemEffectAtom = localForageEffect(
  selectedNavigatorItemAtom,
  'selectedNavigatorItem'
);

export const isOpenAtom = isNavigatorOpenAtom;

export const navigatorTabAtom = atom<NavigatorTab>('vehicle');
export const filterStringAtom = atom<string>('');
export const bluecoinsFilterStringAtom = atom<string>('');
export const waypointsFilterStringAtom = atom<string>('');
export const filteredVehiclesAtom = atom<number[]>([]);
export const isNavigatorDisabledAtom = atom<boolean>(false);
export const showLoaderAtom = atom<boolean>(false);
export const showVehiclesAtom = atom<boolean>(true);
export const showVehicleGroupsAtom = atom<boolean>(false);
export const isNavigatorMinimizedAtom = atom<boolean>(false);
export const hideInactiveVehiclesAtom = atom<boolean>(false);

/** Id of the vehicle whose item menu is open; at most one may be open at a time. */
export const openVehicleItemMenuIdAtom = atom<number | null>(null);
export const isVehicleItemMenuOpenAtomFamily = atomFamily((vehicleId: number) =>
  atom((get) => get(openVehicleItemMenuIdAtom) === vehicleId)
);

export interface VehicleDriverChangeTarget {
  vehicleId: number;
  customerId: number;
}

/**
 * Vehicle whose driver-change modal is open. The modal is rendered by MaximizedNavigator
 * rather than by the row: a React portal still bubbles events up the React tree, so a modal
 * rendered inside the row would feed its clicks and keystrokes to the row's select handler.
 * The list is virtualized too, so the row can unmount while the modal is open.
 */
export const vehicleDriverChangeTargetAtom = atom<VehicleDriverChangeTarget | null>(null);
